import React from 'react';
import { Header, Grid, Icon, Popup } from 'semantic-ui-react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';

const RASCal = React.memo((props) => {
  //console.log("props",props);     
  const selectionRange = {
    startDate: new Date(),
    endDate: new Date(),
    key: 'selection',
  }
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];
  let flowCount = 0;
  let BuildRASRow = React.memo((_mainobj) => {
    //console.log("RAS");  
    return (
      <Grid.Row key={_mainobj.keys} data-index={_mainobj.flow}>
        {_mainobj.attr.map((_obj, _index) => {
          if (_obj.type !== "hide")
            return <BuildRAS keys={_mainobj.keys} attr={_obj} parentobj={_mainobj.attr}></BuildRAS>
        })}
        <Grid.Column width={1} className={`${_mainobj.keys === 0 ? "hide" : ""}`}>
          <Popup content='Delete' trigger={<Icon className="xcm-icon-delete size-20"  onClick={(e) => props.delete(e, _mainobj.keys, true)}></Icon>} />
        </Grid.Column>
      </Grid.Row>
    );
  });
  let BuildRAS = React.memo((_type) => {
    if (_type.attr.type === "month-picker") {
      return (
        <Grid.Column width={2} className="ui form" >
          <div className="field">
            <div className="ui icon input">
              {/*<DayPickerInput placeholder="Date" value={_type.attr.value} onDayChange={day => props.daychange(day,_type.attr.name,_type.keys)} />*/}
              <DatePicker
                dateFormat="dd/MMM"
                placeholderText="Date"
                /* minDate={(_type.attr.name=="EndDate")?new Date(_type.parentobj.filter(vv=>vv.name=="StartDate")[0].value):""}
                 maxDate={(_type.attr.name=="StartDate")?new Date(_type.parentobj.filter(vv=>vv.name=="EndDate")[0].value):""}*/
                renderCustomHeader={({
                  date,
                  changeMonth,
                }) => (
                    <div
                      style={{
                        margin: 10,
                        display: "flex",
                        justifyContent: "center"
                      }}
                    >

                      <select
                        value={months[new Date(date).getMonth()]}
                        onChange={({ target: { value } }) =>
                          changeMonth(months.indexOf(value))
                        }
                      >
                        {months.map(option => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>

                    </div>
                  )}
                selected={(_type.attr.value!=="")?new Date(_type.attr.value):""}
                onChange={date => props.daychange(date, _type.attr.name, _type.keys)}
              />
              <i className="icon calendar alternate"></i></div> </div>
        </Grid.Column>
      );
    }
    else if (_type.attr.type === "editable")
      return (
        <Grid.Column width={1}><div className="RASweek" onKeyPress={(e) => props.keypress(e, _type.attr.name, _type.keys)} onClick={(e) => props.event(e, _type.attr.name, _type.keys)}>{_type.attr.value}</div></Grid.Column>
      );
    else if (_type.attr.type === "noneditable")
      return (
        <Grid.Column width={3}><div className="RASweek"><strong>{_type.attr.value} hours</strong></div></Grid.Column>
      );
  });

  return (<>
    <Header as="h2" dividing className='js-title' >
      Resource Availability (RAS/CAL Only)<Icon className="RASIcon xcm-icon-info icon size-24 p-relative top-minus-2 v-align-bottom orange pointer"  onMouseOver={(e) => props.mouseover(e, true)}></Icon>
    </Header>
    <Grid columns='equal' inverted className="grid-header RAS-grid">
      <Grid.Row className="header">
        <Grid.Column width={2}>  From Date   </Grid.Column>
        <Grid.Column width={2}>   To Date   </Grid.Column>
        <Grid.Column width={1}>    Mon    </Grid.Column>
        <Grid.Column width={1}>     Tue   </Grid.Column>
        <Grid.Column width={1}>    Wed   </Grid.Column>
        <Grid.Column width={1}>    Thu   </Grid.Column>
        <Grid.Column width={1}>    Fri    </Grid.Column>
        <Grid.Column width={1}>    Sat    </Grid.Column>
        <Grid.Column width={1}>     Sun    </Grid.Column>
        <Grid.Column width={3}>   Total Hours / Week </Grid.Column>
        <Grid.Column width={1}>   Delete </Grid.Column>
      </Grid.Row>


      {props.dataObj.map((_arrobj, _index) => {
        if (_arrobj.filter(x => x.name === "Deleted")[0].value === "N")
          return <BuildRASRow keys={_index} attr={_arrobj} flow={flowCount++}></BuildRASRow>
      })}

      <div className="btn-holder-full-width">
        <div className={`errmsg ${props.RASerror ? "errrasshow" : "errrashide"}`}>
        {props.RASerrormsg}
                                </div>
        <button className="ui button primary normal" onClick={(e) => props.click(e)} >Add Schedule</button></div>

    </Grid>

  </>
  );
});

export default RASCal;
